import { Flex } from '@chakra-ui/react';
import { useSidebar } from '../../context/SidebarContext';

interface IChildren {
  children: React.ReactElement;
}

// A margem esquerda acompanha a largura atual da SiderbarResponsive (via
// SidebarContext) — antes era um "ml" fixo de 65px, então quando a sidebar
// expandia no hover pra 250px ela cobria o conteúdo em vez de empurrá-lo.
export const Wapper = ({ children }: IChildren) => {
  const { larguraAtual } = useSidebar();

  return (
    <Flex
      w="100%"
      mt="80px"
      align="flex-start"
      ml={larguraAtual}
      transitionProperty="margin-left"
      transitionDuration="0.3s"
      transitionTimingFunction="ease-in"
    >
      {children}
    </Flex>
  );
};
